(function () {
  'use strict';

  // ── Analytics ───────────────────────────────────────────────────────────────
  // GTM dataLayer push. Guarded so it self-initializes if GTM is blocked or
  // hasn't loaded yet.
  function pushDL(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  // Order economics captured at render time so the CTA click handlers can read them.
  var lastOrderTotalCents = null;
  var lastOrderItemCount  = 0;

  // One-shot: parent_pay_cart_loaded must fire exactly once per load, even though
  // showError() (the failure funnel) is a general-purpose UI helper called from
  // several places and async .catch handlers.
  var cartLoadedFired = false;
  function pushCartLoaded(data) {
    if (cartLoadedFired) return;
    cartLoadedFired = true;
    pushDL('parent_pay_cart_loaded', data);
  }

  // ── URL parsing ───────────────────────────────────────────────────────────────
  var params   = new URLSearchParams(window.location.search);
  var fromName = (params.get('from') || '').trim();
  var noteText = (params.get('note') || '').trim();
  var cartRaw  = params.get('cart') || '';

  // Discounted prices passed through from the teen's cart at share-time.
  // Stored as integers in cents (Shopify's native format).
  // Fall back to null → renderSummary computes from per-item fetched prices.
  var subtotalParam = params.get('subtotal') !== null ? parseInt(params.get('subtotal'), 10) : null;
  var totalParam    = params.get('total')    !== null ? parseInt(params.get('total'),    10) : null;
  if (isNaN(subtotalParam)) subtotalParam = null;
  if (isNaN(totalParam))    totalParam    = null;

  var cartItems = cartRaw.split(',').filter(Boolean).map(function (part) {
    var pieces    = part.split(':');
    if (pieces.length < 3) return null;
    var handle    = pieces[0];
    var variantId = parseInt(pieces[1], 10);
    var qty       = parseInt(pieces[2], 10);
    if (!handle || isNaN(variantId) || isNaN(qty) || qty < 1) return null;
    return { handle: handle, variantId: variantId, qty: qty };
  }).filter(Boolean);

  // ── Stash / mode detection ────────────────────────────────────────────────────
  var SHARE_API_BASE = 'https://share.evryjewels.com';
  var stashSlug  = params.get('k');
  var expiredFlag = params.get('expired') === '1';
  var currencyCode = 'USD'; // overwritten from the stash when present

  // Page-access event — fires on every visit, before the async cart load.
  pushDL('parent_pay_view', {
    share_source: 'parent_pay_page',
    entry_mode: expiredFlag ? 'expired_link' : (stashSlug ? 'stash' : 'legacy'),
  });

  // ── Addon classification ──────────────────────────────────────────────────────
  // Handles confirmed from config/settings_data.json:339,345 and product URL in :340
  var ADDON_HANDLES = [
    'package-protection-1-year-warranty',
    '1-year-warranty',
    'package-protection',
  ];
  var ADDON_HANDLE_KEYWORDS = [
    'package-protection', 'package_protection',
    'warranty', 'shipping-protection', 'shipping_protection', 'insurance',
  ];
  // Titles from assets/cart.js:33-40 (all locales)
  var ADDON_TITLE_KEYWORDS = [
    'package protection', '1 year warranty',
    'protection des colis', 'garantie 1 an', 'paketschutz',
  ];

  function isAddon(product) {
    var h = (product.handle || '').toLowerCase();
    var t = (product.title  || '').toLowerCase();
    var v = (product.vendor || '').toLowerCase();
    var i;
    for (i = 0; i < ADDON_HANDLES.length; i++) {
      if (h === ADDON_HANDLES[i]) return true;
    }
    for (i = 0; i < ADDON_HANDLE_KEYWORDS.length; i++) {
      if (h.indexOf(ADDON_HANDLE_KEYWORDS[i]) !== -1) return true;
    }
    if (v === 'route') return true;
    for (i = 0; i < ADDON_TITLE_KEYWORDS.length; i++) {
      if (t.indexOf(ADDON_TITLE_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  // ── DOM references ────────────────────────────────────────────────────────────
  var heroH1      = document.getElementById('pp-hero-h1');
  var noteWrap    = document.getElementById('pp-note-wrap');
  var cartCountEl = document.getElementById('pp-cart-count');
  var ctaLabel    = 'Complete the order';

  // ── Identity population ───────────────────────────────────────────────────────
  function populateIdentity(name, note) {
    ctaLabel = name ? 'Complete ' + name + '’s order' : 'Complete the order';
    document.querySelectorAll('.pp-cta-btn.pp-cta-protected .pp-cta-label').forEach(function (el) {
      var base = name ? name + '\u2019s' : 'the';
      el.textContent = 'Complete ' + base + ' protected order';
    });
    document.querySelectorAll('.pp-cta-btn:not(.pp-cta-protected) .pp-cta-label').forEach(function (el) { el.textContent = ctaLabel; });
    if (heroH1) {
      heroH1.innerHTML = name
        ? escapeHtml(name) + ' picked a few <em>favourites</em> just for you to see.'
        : 'Someone special picked a few <em>favourites</em> just for you to see.';
    }
    if (noteWrap && (note || name)) {
      document.getElementById('pp-note-label').textContent = name ? 'Note from ' + name : 'A note for you';
      document.getElementById('pp-note-text').textContent = note ? '"' + note + '"' : '"she made a wishlist just for you ✨"';
      var noteSign = document.getElementById('pp-note-sign');
      if (name) { noteSign.innerHTML = '— love, ' + escapeHtml(name) + ' 💗'; }
      else { noteSign.style.display = 'none'; }
      noteWrap.style.display = '';
    }
  }

  // ── Stash sanitizers ──────────────────────────────────────────────────────────
  // stash data is untrusted (anyone can POST to /stash); sanitize at the boundary.

  // Module-level list consumed by doCheckout (built during load)
  var checkoutItems = [];

  function safeImageUrl(url) {
    return (typeof url === 'string' && /^https:\/\/[^\s"'()<>]+$/i.test(url)) ? url : '';
  }

  function safeHandle(h) {
    return (typeof h === 'string' && /^[a-z0-9_-]+$/i.test(h)) ? h : '';
  }

  function safeMarkdown(md) {
    if (!md || typeof md !== 'object') return null;
    var final = Number(md.final);
    if (!isFinite(final)) return null;
    var compare = (md.compare == null) ? null : Number(md.compare);
    if (compare != null && !isFinite(compare)) compare = null;
    var style = (md.style === 'comp_value') ? 'comp_value' : 'strikethrough';
    return { final: final, compare: compare, style: style };
  }

  function stashItemToRow(it) {
    var img = safeImageUrl(it.image);
    return {
      product: {
        title: it.title || '',
        handle: safeHandle(it.handle),
        vendor: '',
        featured_image: img,
        images: img ? [img] : [],
      },
      variant: {
        id: it.id,
        title: it.variant_title || 'Default Title',
        price: Number(it.price) || 0,
        compare_at_price: null,
        featured_image: img ? { src: img } : null,
      },
      qty: Math.max(1, parseInt(it.quantity, 10) || 1),
      properties: it.properties || null,
      selling_plan: it.selling_plan || null,
      markdown: safeMarkdown(it.markdown),
      line_price: (typeof it.line_price === 'number') ? it.line_price : null,
    };
  }

  // ── Skeleton placeholders ─────────────────────────────────────────────────────
  var piecesEl = document.getElementById('pp-pieces');

  function renderSkeleton(n) {
    if (!piecesEl || !n) return;
    var one = '<div class="piece pp-skeleton-piece"><div class="piece-img pp-skel"></div>'
      + '<div class="piece-body"><div><div class="pp-skel" style="height:16px;width:75%;margin-bottom:8px;border-radius:6px;"></div>'
      + '<div class="pp-skel" style="height:12px;width:50%;border-radius:6px;"></div></div>'
      + '<div class="piece-foot" style="margin-top:16px;"><div class="pp-skel" style="height:17px;width:35%;border-radius:6px;"></div>'
      + '<div class="pp-skel" style="height:24px;width:18%;border-radius:100px;"></div></div></div></div>';
    piecesEl.innerHTML = new Array(n).fill(one).join('');
  }

  // ── Finish render (shared by both load paths) ─────────────────────────────────
  function finishRender(rows) {
    var productItems = rows.filter(function (r) { return !isAddon(r.product); });
    var addonItems   = rows.filter(function (r) { return  isAddon(r.product); });
    if (!productItems.length) { showError(); return; }

    checkoutItems = rows.map(function (r) {
      return { id: r.variant.id, quantity: r.qty, properties: r.properties, selling_plan: r.selling_plan };
    });

    if (cartCountEl) {
      cartCountEl.textContent = 'Her cart · ' + productItems.length + ' item' + (productItems.length !== 1 ? 's' : '');
    }
    lastOrderItemCount = productItems.reduce(function (n, r) { return n + r.qty; }, 0);
    renderCards(productItems);
    renderSummary(productItems, addonItems);  // sets lastOrderTotalCents
    setCTAState(true);

    pushCartLoaded({
      share_source: 'parent_pay_page',
      status: 'loaded',
      item_count: lastOrderItemCount,
      value: (lastOrderTotalCents || 0) / 100,
      currency: currencyCode,
    });
  }

  // ── Mode-aware loader ─────────────────────────────────────────────────────────
  setCTAState(false);

  if (expiredFlag) {
    showError('This link has expired. Ask for a fresh one 💗');
    initStatic();
  } else if (stashSlug) {
    renderSkeleton(3);
    fetch(SHARE_API_BASE + '/api/' + encodeURIComponent(stashSlug))
      .then(function (res) { if (!res.ok) throw new Error('stash ' + res.status); return res.json(); })
      .then(function (record) {
        if (record.currency) currencyCode = record.currency;
        if (record.subtotal != null) subtotalParam = record.subtotal;
        if (record.total    != null) totalParam    = record.total;
        fromName = (record.from || '').trim();
        noteText = (record.note || '').trim();
        populateIdentity(fromName, noteText);
        var rows = (record.items || []).map(stashItemToRow);
        if (!rows.length) { showError(); return; }
        finishRender(rows);
      })
      .catch(function (err) {
        console.error('[parent-pay] stash load failed', err);
        showError('Hmm, we couldn’t load these items. The link may have expired.');
      });
    initStatic();
  } else {
    populateIdentity(fromName, noteText);
    renderSkeleton(cartItems.length);
    if (!cartItems.length) { showError('No items found in this link. It may have expired.'); initStatic(); return; }
    Promise.all(cartItems.map(fetchItem)).then(function (results) {
      var rows = results.filter(Boolean).map(function (r) {
        return { product: r.product, variant: r.variant, qty: r.qty, properties: null, selling_plan: null };
      });
      if (!rows.length) { showError(); return; }
      finishRender(rows);
    }).catch(function (err) { console.error('[parent-pay]', err); showError(); });
    initStatic();
  }

  // ── Fetch single product (legacy ?cart= path) ─────────────────────────────────
  function fetchItem(item) {
    return fetch('/products/' + item.handle + '.js')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (product) {
        if (!product) return null;
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === item.variantId) { variant = product.variants[i]; break; }
        }
        if (!variant) {
          console.warn('[parent-pay] variant ' + item.variantId + ' not found in ' + item.handle);
          return null;
        }
        return { product: product, variant: variant, qty: item.qty };
      })
      .catch(function (e) {
        console.error('[parent-pay] fetch failed for ' + item.handle, e);
        return null;
      });
  }

  // ── Render cards ──────────────────────────────────────────────────────────────
  function renderCards(items) {
    if (!piecesEl) return;

    piecesEl.innerHTML = items.map(function (row) {
      var product = row.product;
      var variant = row.variant;
      var qty     = row.qty;

      var imgSrc = (variant.featured_image && variant.featured_image.src)
        || product.featured_image
        || (product.images && product.images[0])
        || '';

      var variantLabel = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
      var md = row.markdown;
      var priceHtml;
      if (row.line_price === 0) {
        priceHtml = '<span class="piece-gift">🎁 Free</span>';
      } else if (md) {
        var finalStr = money(md.final);
        var compStr  = (md.compare != null) ? money(md.compare) : null;
        if (md.style === 'comp_value') {
          priceHtml = finalStr + (compStr ? ' <span class="piece-compvalue">' + compStr + '</span>' : '');
        } else {
          priceHtml = (compStr ? '<s>' + compStr + '</s> ' : '') + finalStr;
        }
      } else {
        var price   = money(variant.price);
        var compare = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? money(variant.compare_at_price) : null;
        priceHtml = (compare ? '<s>' + compare + '</s>' : '') + price;
      }

      return '<div class="piece pp-piece-new" style="opacity:0;transition:opacity .2s ease;">'
        + '<div class="piece-img" style="background-image:url(\'' + imgSrc + '\');"></div>'
        + '<div class="piece-body">'
        +   '<div>'
        +     '<div class="piece-name">' + escapeHtml(product.title) + '</div>'
        +     (variantLabel ? '<div class="piece-variant">' + escapeHtml(variantLabel) + '</div>' : '')
        +   '</div>'
        +   '<div class="piece-foot">'
        +     '<div class="piece-price">' + priceHtml + '</div>'
        +     '<div class="piece-qty">Qty ' + qty + '</div>'
        +   '</div>'
        +   (product.handle ? '<a class="piece-details" href="/products/' + product.handle + '" target="_blank" rel="noopener">Read full details →</a>' : '')
        + '</div>'
        + '</div>';
    }).join('');

    requestAnimationFrame(function () {
      piecesEl.querySelectorAll('.pp-piece-new').forEach(function (el) {
        el.style.opacity = '1';
      });
    });
  }

  // ── Render summary ────────────────────────────────────────────────────────────
  function renderSummary(productItems, addonItems) {
    // Displayed unit price honors a stored fake markdown when present.
    function lineUnit(row) {
      if (row.line_price === 0) return 0; // free gift / fully-discounted line
      return (row.markdown && isFinite(row.markdown.final)) ? row.markdown.final : row.variant.price;
    }
    var anyMarkdown = productItems.some(function (r) { return r.markdown; });

    var computedSubtotal = productItems.reduce(function (sum, row) {
      return sum + lineUnit(row) * row.qty;
    }, 0);
    var computedAddons = addonItems.reduce(function (sum, row) {
      return sum + row.variant.price * row.qty;
    }, 0);

    var displaySubtotal, displayTotal, savingsCents;
    if (anyMarkdown) {
      // Marked-down prices are authoritative so cards + summary agree.
      displaySubtotal = computedSubtotal + computedAddons;
      displayTotal    = computedSubtotal + computedAddons;
      savingsCents    = 0;
    } else {
      displaySubtotal = (subtotalParam !== null) ? subtotalParam : computedSubtotal + computedAddons;
      displayTotal    = (totalParam    !== null) ? totalParam    : computedSubtotal + computedAddons;
      savingsCents    = (subtotalParam !== null && totalParam !== null && subtotalParam > totalParam)
        ? subtotalParam - totalParam : 0;
    }

    lastOrderTotalCents = displayTotal;

    var subtotalEl = document.getElementById('pp-summary-subtotal');
    var totalEl    = document.getElementById('pp-summary-total');
    if (subtotalEl) subtotalEl.textContent = money(displaySubtotal);
    if (totalEl)    totalEl.textContent    = money(displayTotal);
    document.querySelectorAll('.pp-sticky-total').forEach(function (el) {
      el.textContent = money(displayTotal);
    });

    // Bundle savings row — inserted immediately after the Subtotal row
    if (savingsCents > 0) {
      var savingsHtml = '<div class="summary-row summary-row-savings">'
        + '<span>Bundle savings</span>'
        + '<span>−' + money(savingsCents) + '</span>'
        + '</div>';
      var subtotalSpan = document.getElementById('pp-summary-subtotal');
      if (subtotalSpan) subtotalSpan.closest('.summary-row').insertAdjacentHTML('afterend', savingsHtml);
    }

    // Addon rows — inserted before the Shipping row
    if (addonItems.length) {
      var addonHtml = addonItems.map(function (row) {
        var title = row.product.title || 'Add-on';
        if (title.length > 30) title = title.slice(0, 30) + '…';
        return '<div class="summary-row summary-row-addon">'
          + '<span>🛡️ ' + escapeHtml(title) + '</span>'
          + '<span>' + money(row.variant.price * row.qty) + '</span>'
          + '</div>';
      }).join('');
      var shippingRow = document.querySelector('.summary-row-shipping');
      if (shippingRow) shippingRow.insertAdjacentHTML('beforebegin', addonHtml);
    }
  }

  // ── CTA state (loading/idle) ──────────────────────────────────────────────────

  // aria-disabled pattern — browser never swallows click events,
  // handler fires and guards itself with the attribute check.
  function setCTAState(enabled) {
    document.querySelectorAll('.pp-cta-btn').forEach(function (btn) {
      if (enabled) {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-disabled', 'is-loading');
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-disabled');
      }
    });
  }

  // In-flight loading state — locks both CTAs while checkout is in progress.
  function setCTALoading(loading) {
    document.querySelectorAll('.pp-cta-btn').forEach(function (btn) {
      var labelEl = btn.querySelector('.pp-cta-label');
      var arrowEl = btn.querySelector('svg');
      var spinner = btn.querySelector('.pp-spinner');

      if (loading) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-disabled', 'is-loading');
        if (labelEl) labelEl.textContent = 'Taking you to checkout...';
        if (arrowEl) arrowEl.style.display = 'none';
        if (!spinner) {
          var s = document.createElement('span');
          s.className = 'pp-spinner';
          s.setAttribute('aria-hidden', 'true');
          btn.appendChild(s);
        }
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-disabled', 'is-loading');
        if (labelEl) labelEl.textContent = ctaLabel;
        if (arrowEl) arrowEl.style.display = '';
        if (spinner) spinner.remove();
      }
    });
  }

  // ── Checkout ──────────────────────────────────────────────────────────────────
  function buildCartItems(includeProtection) {
    var items = checkoutItems.map(function (it) {
      var line = { id: it.id, quantity: it.quantity };
      if (it.properties && Object.keys(it.properties).length) line.properties = it.properties;
      if (it.selling_plan) line.selling_plan = it.selling_plan;
      return line;
    });

    if (includeProtection) {
      var protectionWrap = document.querySelector('.pp-protection-wrap');
      if (protectionWrap) {
        var protectionVariantId = parseInt(protectionWrap.getAttribute('data-protection-variant-id'), 10);
        if (protectionVariantId) {
          items.push({ id: protectionVariantId, quantity: 1 });
        }
      }
    }
    return items;
  }

  // Fires on a genuine (non-disabled) checkout-start click. value is recalculated
  // to include the package-protection charge only when it will actually be added
  // to the cart (with_protection AND the protection block is present on the page).
  function trackCompleteClick(btn, withProtection) {
    // No order to complete yet (cart still loading / failed) — don't emit a value:0 click.
    if (lastOrderTotalCents === null) return;
    var protectionCents = 0;
    if (withProtection) {
      var wrap = document.querySelector('.pp-protection-wrap');
      // Mirror buildCartItems: protection is only added when a variant id is present.
      if (wrap && parseInt(wrap.getAttribute('data-protection-variant-id'), 10)) {
        protectionCents = parseInt(wrap.getAttribute('data-protection-price'), 10) || 299;
      }
    }
    pushDL('parent_pay_complete_click', {
      share_source: 'parent_pay_page',
      cta_location: (btn && btn.closest && btn.closest('#pp-sticky-cta')) ? 'sticky' : 'top',
      with_protection: !!withProtection,
      value: ((lastOrderTotalCents || 0) + protectionCents) / 100,
      currency: currencyCode,
      item_count: lastOrderItemCount,
    });
  }

  function doCheckout() {
    if (this.getAttribute && this.getAttribute('aria-disabled') === 'true') return;
    trackCompleteClick(this, true);
    performCheckout(true);
  }

  function doCheckoutWithoutProtection() {
    trackCompleteClick(this, false);
    performCheckout(false);
  }

  function performCheckout(includeProtection) {
    var prevErr = document.getElementById('pp-cta-error');
    if (prevErr) prevErr.remove();
    setCTALoading(true);

    var items = buildCartItems(includeProtection);

    fetch('/cart/clear.js', { method: 'POST' })
      .catch(function (e) { console.warn('[parent-pay] /cart/clear.js failed (continuing)', e); })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (body) {
            throw new Error(body.description || body.message || 'Add to cart failed (' + res.status + ')');
          });
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { source: 'parent_pay', daughter_name: fromName, daughter_note: noteText },
            note: noteText || undefined,
          }),
        }).catch(function (e) { console.warn('[parent-pay] /cart/update.js failed (continuing)', e); });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error('[parent-pay] checkout error', err);
        setCTALoading(false);
        showCtaError('Hmm, something went wrong. Try again?');
      });
  }

  // ── Inline CTA error ──────────────────────────────────────────────────────────
  function showCtaError(msg) {
    var errEl = document.createElement('p');
    errEl.id = 'pp-cta-error';
    errEl.className = 'pp-cta-error-msg';
    errEl.textContent = msg;
    var ctaWrap = document.querySelector('.cta-wrap');
    if (ctaWrap) ctaWrap.appendChild(errEl);
  }

  // ── Error state (product load failure) ───────────────────────────────────────
  function showError(msg) {
    pushCartLoaded({
      share_source: 'parent_pay_page',
      status: 'unavailable',
    });
    if (piecesEl) {
      piecesEl.innerHTML =
        '<div class="pp-error">'
        + '<p>' + (msg || "Hmm, we couldn’t load these items. The link may have expired.") + '</p>'
        + '<a href="/" class="cta" style="display:inline-flex;margin-top:16px;text-decoration:none;padding:14px 24px;width:auto;">Visit Evry Jewels</a>'
        + '</div>';
    }
    setCTAState(false);
  }

  // ── Static behaviours (FAQ + sticky CTA) ─────────────────────────────────────
  function initStatic() {
    // FAQ accordion
    document.querySelectorAll('.faq-item').forEach(function (item) {
      item.addEventListener('click', function () { item.classList.toggle('open'); });
    });

    // Sticky CTA scroll trigger
    var stickyCta  = document.getElementById('pp-sticky-cta');
    var primaryCta = document.getElementById('pp-primary-cta');
    if (stickyCta && primaryCta) {
      window.addEventListener('scroll', function () {
        stickyCta.classList.toggle('show', primaryCta.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    // CTA click — protected checkout buttons
    document.querySelectorAll('.pp-cta-btn').forEach(function (btn) {
      btn.addEventListener('click', doCheckout);
    });

    // "Continue without protection" buttons
    document.querySelectorAll('.pp-cta-without').forEach(function (btn) {
      btn.addEventListener('click', doCheckoutWithoutProtection);
    });
  }

  // ── Utilities ─────────────────────────────────────────────────────────────────
  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode })
        .format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = String(s || '');
    return d.innerHTML;
  }

})();
